import type { FilesKeyframeSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/files';

const settledStatuses = new Set(['CLOSED', 'ACTIVE']);

const isDisplayable = (
  item: FilesKeyframeSchemaWithIdNullable,
  allowGrowing: boolean,
) => {
  if (!item.status) {
    return false;
  }
  if (settledStatuses.has(item.status)) {
    return true;
  }
  return allowGrowing && item.type === 'KEYFRAME' && item.status === 'GROWING';
};

export const getKeyframesAndPosters = (
  keyframes: FilesKeyframeSchemaWithIdNullable[],
  allowGrowing = false,
) =>
  keyframes.filter(
    (item) =>
      item.type !== 'KEYFRAME_MAP' &&
      isDisplayable(item, allowGrowing) &&
      item.url &&
      item.resolution?.height &&
      item.resolution?.width,
  );
